import React from 'react';

import type DocumentWithMembershipStore from 'stores/DocumentWithMembershipStore';

import EditMemberButton from './EditMemberButton';
import { Container } from './MemberActionButtons.styles';
import RemoveMemberButton from './RemoveMemberButton';

export interface MemberActionButtonsProps {
  memberId: string;
  parentDocument: DocumentWithMembershipStore;
}

function MemberActionButtons({
  memberId,
  parentDocument,
}: MemberActionButtonsProps) {
  return (
    <Container>
      <RemoveMemberButton parentDocument={parentDocument} memberId={memberId} />
      <EditMemberButton parentDocument={parentDocument} memberId={memberId} />
    </Container>
  );
}

export default MemberActionButtons;
